module.exports = __webpack_public_path__ + "static/media/platform-screen1.25a92395.jpg";